module.exports = __webpack_public_path__ + "img/dois.01e44de1.png";